import { render, staticRenderFns } from "./PdpRaddar.vue?vue&type=template&id=32019cd6&scoped=true"
import script from "./PdpRaddar.vue?vue&type=script&lang=js"
export * from "./PdpRaddar.vue?vue&type=script&lang=js"
import style0 from "./PdpRaddar.vue?vue&type=style&index=0&id=32019cd6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32019cd6",
  null
  
)

export default component.exports